module.exports = __webpack_public_path__ + "img/img_eshop03.1de96b56.jpg";